import analytics from '../../../services/analytics';

/**
 * Enhanced analytics tracking for landing page conversion funnel
 */
export const landingAnalytics = {
  // Track the conversion funnel
  trackFunnelStep: (step, properties = {}) => {
    if (!analytics.initialized) return;
    
    const funnelSteps = {
      'landing_page_view': 1,
      'cta_click': 2,
      'email_modal_opened': 3,
      'email_submitted': 4
    };

    analytics.track(`funnel_step_${step}`, {
      step_name: step,
      step_number: funnelSteps[step] || 0,
      timestamp: new Date().toISOString(),
      ...properties
    });
  },

  // Track scroll depth
  trackScrollDepth: (depth) => {
    if (!analytics.initialized) return;
    
    analytics.track('landing_scroll_depth', {
      depth_percentage: depth,
      timestamp: new Date().toISOString()
    });
  },

  // Track time on page before interaction
  trackTimeToInteraction: (interactionType, timeInSeconds) => {
    if (!analytics.initialized) return;
    
    analytics.track('time_to_interaction', {
      interaction_type: interactionType,
      time_seconds: timeInSeconds,
      time_formatted: `${Math.floor(timeInSeconds / 60)}m ${timeInSeconds % 60}s`
    });
  },

  // Track demo interactions with more detail
  trackDemoInteraction: (action, properties = {}) => {
    if (!analytics.initialized) return;
    
    analytics.track(`demo_${action}`, {
      action,
      timestamp: new Date().toISOString(),
      ...properties
    });
  },

  // Initialize scroll depth tracking
  initScrollTracking: () => {
    let maxScroll = 0;
    const scrollThresholds = [25, 50, 75, 90, 100];
    
    const handleScroll = () => {
      const scrollPercentage = Math.round(
        (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
      );
      
      // Track when hitting new thresholds
      scrollThresholds.forEach(threshold => {
        if (scrollPercentage >= threshold && maxScroll < threshold) {
          landingAnalytics.trackScrollDepth(threshold);
        }
      });
      
      maxScroll = Math.max(maxScroll, scrollPercentage);
    };

    // Throttle scroll events
    let scrollTimer = null;
    window.addEventListener('scroll', () => {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(handleScroll, 150);
    });

    // Track initial page view
    landingAnalytics.trackFunnelStep('landing_page_view', {
      referrer: document.referrer,
      url: window.location.href,
      user_agent: navigator.userAgent
    });
  },

  // Track page load time
  trackPageLoadTime: () => {
    if (!analytics.initialized) return;
    
    if (window.performance && window.performance.timing) {
      const timing = window.performance.timing;
      const loadTime = timing.loadEventEnd - timing.navigationStart;
      
      analytics.track('page_load_time', {
        load_time_ms: loadTime,
        load_time_seconds: (loadTime / 1000).toFixed(2)
      });
    }
  }
};

// Time tracking helper
let pageLoadTime = Date.now();
export const getTimeOnPage = () => {
  return Math.floor((Date.now() - pageLoadTime) / 1000);
};